import { WhiteLabelConfig } from '../models/whitelabel.model';

/**
 * Configuração padrão do white-label para o WKF Tracker.
 */
export const WHITELABEL_CONFIG: WhiteLabelConfig = {
  appName: 'Workfinity Tracker',
  primaryColor: '#556ee6',
  secondaryColor: '#74788d',
  footerText: '',

  lightTheme: {
    logos: {
      logo: 'assets/images/logos/logo-wkf-tracker.svg',
      logoSmall: 'assets/images/logos/logo-wkf-tracker.svg',
      logoLogin: 'assets/images/logos/logo-wkf-tracker.svg',
      favicon: 'favicon.ico',
    },
    header: {
      backgroundColor: '#fdfdfd',
      textColor: '#495057',
    },
    sidebar: {
      backgroundColor: '#101D33',
      menuItemColor: '#545a6d',
      menuItemHoverColor: '#d8dbddff',
      menuItemActiveColor: '#ffffff',
      iconColor: '#545a6d',
    },
  },

  darkTheme: {
    logos: {
      logo: 'assets/images/logos/logo-wkf-tracker.svg',
      logoSmall: 'assets/images/logos/logo-wkf-tracker.svg',
      logoLogin: 'assets/images/logos/logo-wkf-tracker.svg',
      favicon: 'favicon.ico',
    },
    header: {
      backgroundColor: '#101d33',
      textColor: '#e9ecef',
    },
    sidebar: {
      backgroundColor: '#101d33',
      menuItemColor: '#a6b0cf',
      menuItemHoverColor: '#ffffff',
      menuItemActiveColor: '#ffffff',
      iconColor: '#6a7187',
    },
  },
};
